import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";
import AddAnnouncement from "./AddAnnouncement";
import GetAllAnnouncement from "./GetAllAnnouncement";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import { Col, Row } from "antd";

const Announcement = (props) => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	return (
		<div>
			<PageTitle title='Back' />
			<Row gutter={16} className="mt-5">
				<Col span={8}>
					<UserPrivateComponent permission='create-announcement'>
						<AddAnnouncement />
					</UserPrivateComponent>
				</Col>
				<Col span={16}>
					<UserPrivateComponent permission='readAll-announcement'>
						<GetAllAnnouncement />
					</UserPrivateComponent>
				</Col>
			</Row>
		</div>
	);
};

export default Announcement;
